
import { Vue, Component, Prop } from 'vue-property-decorator'
  @Component
export default class HistorySign extends Vue {
    @Prop() signHistoryList: any

    pointStatus: any = {
      1: '未开始',
      2: '进行中',
      3: '已完成',
      4: '已跳过'
    }

    colorList(type, time, val) {
      if(type === 1) {  // 签到
        val['sign_type'] = ''
        return '#D9FBA5'
      } else if (type === 3) {   // 旷课
        val['sign_type'] = '旷课'
        return '#F7C4CB'
      } else if (type === 7) {
        if (Date.parse(<any>new Date())/1000 > time) {  // 待签到
          val['sign_type'] = '待签到'
          return '#F9D59E'
        } else { // 未开课
        val['sign_type'] = '未开课'
          return '#F2F2F2'
        }
      }
    }

}
